const style = {
  wideCell: {
    sx: {
      maxWidth: 220,
      verticalAlign: 'top',
    },
  },
  narrowCell: {
    sx: {
      maxWidth: 140,
      verticalAlign: 'top',
    },
  },
  menuCell: {
    sx: {
      width: 56,
      verticalAlign: 'top',
    },
  },
  wrappingChip: {
    sx: {
      height: 'auto',
      mt: 0.5,
      '& .MuiChip-label': {
        whiteSpace: 'normal',
      },
    },
  },
  ellipsis: {
    sx: {
      maxWidth: 140,
    },
  },
} as const;

export default style;
